module.exports = __webpack_public_path__ + "static/media/entercode.dddae2d9.png";